export const SYNC_USERS_REQUESTS = '@@usersRequests/sync'

export const SET_USERS_REQUESTS = '@@usersRequests/set'

export const UPDATE_USERS_REQUESTS = '@@usersRequests/update'
